module.exports = __webpack_public_path__ + "img/Photo_2__Third_Canal_976_280_2.ed4c60b9.jpg";